import { accounting } from '@/localize.js'
import { useCore } from '@/composables/core/index.js'

const countDecimals = (num) => {
  const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/)
  if (!match) { return 0 }
  return Math.max(
    0,
    // Number of digits right of decimal point.
    // Adjust for scientific notation.
    (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0))
}

const DEFAULT_DECIMAL_DIGITS = 2

export function formatCurrency (value = 0.0, {
  decimalDigits = DEFAULT_DECIMAL_DIGITS,
  currency,
} = {}) {
  const core = useCore()
  const defaultCurrency = core.store.state.routingConfig?.config?.default_currency

  if (!defaultCurrency && !currency) {
    throw Error('No `default_currency` in the store or `currency` as param specified')
  }

  if (decimalDigits === 'auto') {
    const decimalDigitsCount = countDecimals(value)

    // we want at least two decimal digits in auto mode
    decimalDigits = decimalDigitsCount > 2
      ? decimalDigitsCount
      : DEFAULT_DECIMAL_DIGITS
  }

  const options = { precision: decimalDigits }

  if (currency && currency !== defaultCurrency) {
    options.symbol = currency
  }

  return accounting.formatMoney(value * 1.0, options)
}
